'use strict';

import {
	RESET_STATE,
	SET_PRODUCT_TRANSLATION,
	UPDATE_BATCH_FORM,
	ADD_BATCH_LIST,
	REMOVE_BATCH_LIST_ITEM,
	UPDATE_PRODUCT_TRANSLATION,
	EDIT_BATCH_LIST_ITEM,
} from './productTranslations.actions';

const defaultState = {
	data: {
		productTranslation: {},
		originalProductTranslation: {},
		batchForm: {},
		batchList: [],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_PRODUCT_TRANSLATION:
			return {
				...state,
				data: {
					...state.data,
					productTranslation: payload,
					originalProductTranslation: payload,
				},
			};

		case UPDATE_PRODUCT_TRANSLATION: {
			return {
				...state,
				data: {
					...state.data,
					productTranslation: {
						...state.data.productTranslation,
						...payload,
					},
				},
			};
		}

		// batch
		case UPDATE_BATCH_FORM: {
			return {
				...state,
				data: {
					...state.data,
					batchForm: {
						...state.data.batchForm,
						...payload,
					},
				},
			};
		}

		case ADD_BATCH_LIST: {
			return {
				...state,
				data: {
					...state.data,
					batchList: payload,
				},
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.map((entry) => {
						if (entry.identifier === payload.identifier)
							return {
								...entry,
								...payload,
							};

						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case RESET_STATE:
			return defaultState;

		default:
			return state;
	}
}

export default reducer;
